/**
 * Changes made:
 * - 2025-11-06: Updated FAQ heading to "Sprzedaż samochodu online – Często zadawane pytania" with h2 tag and responsive text sizing
 * - 2026-06-30: Updated FAQ answers for speed and buyer questions to match the new business model
 */

import { Laptop, Clock, Gavel } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const Benefits = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <h2 className="text-5xl font-heebo font-bold text-center mb-20" style={{ fontWeight: 700 }}>
          <span className="text-heading">Sprzedaż samochodu online – dlaczego</span> <span className="text-primary">Autaro.pl</span>
        </h2>
        <div className="grid md:grid-cols-3 gap-12">
          <div className="group p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="flex justify-center mb-6">
              <Laptop className="h-16 w-16 text-primary group-hover:text-iris transition-colors" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-heading group-hover:text-primary transition-colors">
              Sprzedaż online bez opłat
            </h3>
            <p className="text-subtitle leading-relaxed">
              Sprzedaż samochodu na Autaro.pl jest całkowicie darmowa, a wszystko załatwisz wygodnie z domu.
            </p>
          </div>
          
          <div className="group p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="flex justify-center mb-6">
              <Clock className="h-16 w-16 text-primary group-hover:text-iris transition-colors" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-heading group-hover:text-primary transition-colors">
              Szybka sprzedaż samochodu
            </h3>
            <p className="text-subtitle leading-relaxed">
              Sprzedaż samochodu na Autaro.pl to szybki i prosty proces – możesz sprzedać samochód nawet w 24–48 godzin.
            </p>
          </div>
          
          <div className="group p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 text-center">
            <div className="flex justify-center mb-6">
              <Gavel className="h-16 w-16 text-primary group-hover:text-iris transition-colors" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-heading group-hover:text-primary transition-colors">
              Konkurencyjna cena i bezpieczna transakcja
            </h3>
            <p className="text-subtitle leading-relaxed">
              Nasza sieć zweryfikowanych komisów z całej Polski zapewnia dostęp do najwyższych ofert oraz bezpiecznej i profesjonalnej transakcji.
            </p>
          </div>
        </div>

        <div id="faq" className="mt-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heebo font-bold text-center mb-12" style={{ fontWeight: 700 }}>
            <span className="text-heading">Sprzedaż samochodu online –</span> <span className="text-primary">Często zadawane pytania</span>
          </h2>
          <div className="max-w-4xl mx-auto">
            <Accordion type="multiple" className="space-y-4">
              <AccordionItem value="item-1" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-0 px-6">
                <AccordionTrigger className="text-left text-lg font-bold text-heading hover:text-primary py-6">
                  Czy sprzedaż samochodu na autaro.pl jest naprawdę bezpłatna?
                </AccordionTrigger>
                <AccordionContent className="text-subtitle leading-relaxed pb-6">
                  Tak, sprzedaż samochodu na autaro.pl jest całkowicie bezpłatna. Nie pobieramy od sprzedających żadnych opłat.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-0 px-6">
                <AccordionTrigger className="text-left text-lg font-bold text-heading hover:text-primary py-6">
                  Jak szybka jest sprzedaż samochodu na Autaro.pl?
                </AccordionTrigger>
                <AccordionContent className="text-subtitle leading-relaxed pb-6">
                  Na Autaro.pl możesz otrzymać ofertę na swój samochód już w ciągu 24–48 godzin. Jak tylko profil samochodu zostanie uzupełniony, twój samochód jest dostępny dla naszej sieci zweryfikowanych komisów i skupów.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-0 px-6">
                <AccordionTrigger className="text-left text-lg font-bold text-heading hover:text-primary py-6">
                  Kto kupi mój samochód?
                </AccordionTrigger>
                <AccordionContent className="text-subtitle leading-relaxed pb-6">
                  Na Autaro.pl, twój samochód jest dostępny wyłącznie dla naszej sieci zweryfikowanych komisów i skupów, co zapewnia bezpieczny, szybki i prosty proces sprzedaży.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-4" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-0 px-6">
                <AccordionTrigger className="text-left text-lg font-bold text-heading hover:text-primary py-6">
                  Ile jest wart mój samochód?
                </AccordionTrigger>
                <AccordionContent className="text-subtitle leading-relaxed pb-6">
                  Autaro.pl korzysta z bieżących danych rynkowych, aby wycenić Twój samochód. Wystarczy, że podasz numer VIN, przebieg oraz rodzaj skrzyni biegów, a natychmiast otrzymasz swoją wycenę!
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};